// Real client reviews. Paste genuine reviews here — each item needs a quote,
// the customer's first name and their suburb or business type. Example:
//   { quote: "...", name: "Sarah", detail: "Scarborough" },
export const REVIEWS = [];
